import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify'

// Paginas
import Home from './pages/Home'
import DashboardPage from './pages/Dashboard'
import ColaboradoresPage from './pages/colaborador/Colaboradores'
import ColaboradorPage from './pages/colaborador/Colaborador'
import LoginPage from './pages/Login'
import EmpresasPage from './pages/painelControle/empresas/EmpresasPage'
import EmpresaCadastrarPage from './pages/painelControle/empresas/EmpresaCadastrarPage'
import CargosPage from './pages/painelControle/cargos/CargosPage';
import CargosCadastrarEditarPage from './pages/painelControle/cargos/CargosCadastrarEditarPage';
import CentroCustoPage from './pages/painelControle/centro_custo/CentroCustoPage';
import CentroCustoCadastrarPage from './pages/painelControle/centro_custo/CentroCustoCadastrarPage';
import LocalTrabalhoPage from './pages/painelControle/local_trabalho/LocalTrabalhoPage';
import LocalTrabalhoFormPage from './pages/painelControle/local_trabalho/LocalTrabalhoFormPage';
import SituacoesPage from './pages/painelControle/situacoes/SituacoesPage';
import DefinicoesAppPage from './pages/painelControle/definicoes_app/DefinicoesAppPage';
import UsuariosPage from './pages/painelControle/usuarios/UsuariosPage';
import UsuariosFormPage from './pages/painelControle/usuarios/UsuariosFormPage';

// NF
import NFSelecaoEmpresasPage from './pages/nf/SelecaoEmpresas';

// Despesas
import FrotaDespesasPage from './pages/despesas/frota/Custos';

import ErrorPage from "./pages/ErrorPage";
import ResetCss from './styles/reset_css'
import GlobalCss from './styles/global_css'

import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import SituacoesFormPage from './pages/painelControle/situacoes/SituacoesFormPage';
import ConsultarApuracaoPage from './pages/apuracao/ConsultarPage';
import ApuracaoPage from './pages/apuracao/ApuracaoPage';
import MarcacoesPage from './pages/pontoDigital/MarcacoesPage';
import OcorrenciasPage from './pages/pontoDigital/OcorrenciaPage';
import FolhaPontoPage from './pages/pontoDigital/FolhaPontoPage';
import NfEmpresasPage from './pages/nf/EmpresasPage';
import NfEmpresasFormPage from './pages/nf/EmpresasCadastraPage';
import NfClientesPage from './pages/nf/ClientesPage';
import NfClientesFormPage from './pages/nf/ClientesCadastrarPage';
import NfInicialPage from './pages/nf/Inicial';
import NfModelosPage from './pages/nf/NotaModelo';
import NfCadastrarModeloPage from './pages/nf/pageNotaModelo/NfsCadastrarModelo';
import NfTiposClientesPage from './pages/nf/ClientesTiposPage';
import NfClientesTiposFormPage from './pages/nf/ClientesTiposCadastrarPage';
import NfServicosPage from './pages/nf/servicos/ServicosPage';
import NfServicoEditarPage from './pages/nf/servicos/ServicosEditarPage';
import NfServicosEmpresasPage from './pages/nf/servicos/ServicosEmpresasPage';
import NfServicosEmpresaEditarPage from './pages/nf/servicos/ServicosEmpresasEditarPage';
import NfCidadesPage from './pages/nf/cidades/CidadesPage';
import NfCidadeFormPage from './pages/nf/cidades/CidadesFormPage';
import NfConfigFormPage from './pages/nf/ConfigPage';
import DespesasClientesPage from './pages/despesas/clientes/DespesasClientesPage';
import DespesasClienteFormPage from './pages/despesas/clientes/DespesasClientesForm';
import DespesasFormasPagamentoPage from './pages/despesas/formasPagamento/DespesasFormasPagamentoPage';
import DespesasFormaPagamentoFormPage from './pages/despesas/formasPagamento/DespesasFormasPagamentoForm';
import DespesasCartoesPage from './pages/despesas/cartoes/DespesasCartoesPage';
import DespesasCartoesFormPage from './pages/despesas/cartoes/DespesasCartoesFormPage';
import DespesasCategoriasPage from './pages/despesas/categorias/DespesasCategoriasPage';
import DespesasCategoriasFormPage from './pages/despesas/categorias/DespesasCategoriasFormPage';
import MetricasPage from './pages/metricas/MetricasPage';
import QrCodesPage from './pages/qrcode/QrCodesPage';
import QrCodeCadastrarPage from './pages/qrcode/QrCodeCadastrar';
import QrCodesRegistrosPage from './pages/qrcode/QrCodesRegistros';
import DocumentosPendentesPage from './pages/documentos/pendentes/DocumentosPendentesPage';
import DocumentosPage from './pages/documentos/all/DocumentosPage';
import { store } from './store';
import { Provider } from 'react-redux'
import DocumentoViewPage from './pages/documentos/documento/DocumentoViewPage';
import DocumentosLixeiraPage from './pages/documentos/lixeira/DocumentosLixeiraPage';
import EmissaoPage from './pages/nf/nfse/emissao/EmissaoPage';
import NFSeServicosPage from './pages/nf/nfse/servicos/NFSeServicosPage';
import NFSeServicoEditarPage from './pages/nf/nfse/servicos/NFSeServicosEditarPage';
import NfseModelosListarPage from './pages/nf/nfse/modelos/NFSeModelosListarPage';
import NFSeModeloCadastrarPage from './pages/nf/nfse/modelos/NFSeModeloCadastrarPage';
import RelatoriosPage from './pages/despesas/relatorios/RelatoriosPage';
import DespesasMetricasPage from './pages/despesas/relatorios/DespesasMetricasPage';
import InsumosLocaisPage from './pages/insumos/locais/InsumosLocaisPage';
import InsumosLocaisFormPage from './pages/insumos/locais/InsumosLocaisFormPage';
import InsumosProdutosPage from './pages/insumos/produtos/InsumosProdutosPage';
import InsumosProdutosFormPage from './pages/insumos/produtos/InsumosProdutosFormPage';
import InsumosUnidadesPage from './pages/insumos/unidades/InsumosUnidadesPage';
import InsumosUnidadesFormPage from './pages/insumos/unidades/InsumosUnidadesFormPage';
import InsumosPedidosPage from './pages/insumos/pedidos/PedidosPage';
import NFSeServicosMunPage from './pages/nf/nfse/servicos_mun/NFSeServicosMunPage';
import NFSeServicosMunEditarPage from './pages/nf/nfse/servicos_mun/NFSeServicoMunEditarPage';
import InsumosEstoquePage from './pages/insumos/estoque/consultar/EstoquePage';
import DocumentoNovoPage from './pages/documentos/criar/NovoDocumentoPage';
import QrCodeRondaMapaRelatorioPage from './pages/qrcode/rondaMapa/QrCodeRondaMapaRelatorioPage';
import RondasPage from './pages/qrcode/rondaCadastro/RondasPage';
import MetricasEmpresasPage from './pages/metricas_empresas/MetricasEmpresasPage';
import ComunicadosPage from './pages/comunicados/listar/ComunicadosPage';
import ComunicadosFormPage from './pages/comunicados/form/ComunicadosFormPage';
import EscalasPage from './pages/pontoDigital/escalas/EscalasPage';
import EscalasFormPage from './pages/pontoDigital/escalas/form/EscalasFormPage';
import EscalasTiposPage from './pages/pontoDigital/escalas/tipos/EscalasTipoPage';
import RondasRegistrosPage from './pages/qrcode/rondaConsulta/RondasRegistrosPage';
// import EmpresasSelecaoPage from './pages/nf/nfse/emissao/EmpresasSelecaoPage';

const router = createBrowserRouter([
  {
    path: '/metricas',
    element: <MetricasPage />
    },
  {
    path: '/metricas/sites',
    element: <MetricasEmpresasPage />
  },
  {
    path: "/",
    element: <Home />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'dashboard',
        element: <DashboardPage />
      },
      {
        path: 'colaboradores',
        element: <ColaboradoresPage />
      },
      {
        path: 'colaborador',
        element: <ColaboradorPage />
      },
      {
        path: 'ponto/marcacoes',
        element: <MarcacoesPage />
      },
      {
        path: 'ponto/ocorrencias',
        element: <OcorrenciasPage />
      },
      {
        path: 'ponto/folha',
        element: <FolhaPontoPage />
      },
      {
        path: 'ponto/consultar',
        element: <ConsultarApuracaoPage />
      },
      {
        path: 'ponto/apuracao',
        element: <ApuracaoPage />
      },
      {
        path: 'ponto/escalas',
        element: <EscalasPage />
      },
      {
        path: 'ponto/escala/cadastrar',
        element: <EscalasFormPage />
      },
      {
        path: 'ponto/escala/editar',
        element: <EscalasFormPage />
      },
      {
        path: 'ponto/escalas/tipos',
        element: <EscalasTiposPage />
      },
      {
        path: 'comunicados',
        element: <ComunicadosPage />
      },
      {
        path: 'comunicado/cadastrar',
        element: <ComunicadosFormPage />
      },
      {
        path: 'comunicado/editar',
        element: <ComunicadosFormPage />
      },
      {
        path: 'nfse',
        element: <EmissaoPage />
      },
      {
        path: 'nfse/servicos',
        element: <NFSeServicosPage />
      },
      {
        path: 'nfse/servico',
        element: <NFSeServicoEditarPage />
      },
      {
        path: 'nfse/servicos_mun',
        element: <NFSeServicosMunPage />
      },
      {
        path: 'nfse/servico_mun',
        element: <NFSeServicosMunEditarPage />
      },
      {
        path: 'nfse/modelos',
        element: <NfseModelosListarPage />
      },
      {
        path: 'nfse/modelo',
        element: <NFSeModeloCadastrarPage />
      },
      {
        path: 'nfs',
        element: <NfInicialPage />
      },
      {
        path: 'nf',
        element: <NFSelecaoEmpresasPage />
      },
      {
        path: 'nf/empresas',
        element: <NfEmpresasPage />
      },
      {
        path: 'nf/empresas/consultar',
        element: <NfEmpresasFormPage />
      },
      {
        path: 'nf/clientes',
        element: <NfClientesPage />
      },
      {
        path: 'nf/modelos',
        element: <NfModelosPage />
      },
      {
        path: 'nf/modelo',
        element: <NfCadastrarModeloPage />
      },
      {
        path: 'nf/clientes/consultar',
        element: <NfClientesFormPage />
      },
      {
        path: 'nf/clientes/tipos',
        element: <NfTiposClientesPage />
      },
      {
        path: 'nf/clientes/tipo',
        element: <NfClientesTiposFormPage />
      },
      {
        path: 'nf/servicos',
        element: <NfServicosPage />
      },
      {
        path: 'nf/servico/cadastrar',
        element: <NfServicoEditarPage />
      },
      {
        path: 'nf/servico/editar',
        element: <NfServicoEditarPage />
      },
      {
        path: 'nf/servicos/empresas',
        element: <NfServicosEmpresasPage />
      },
      {
        path: 'nf/servicos/empresa/editar',
        element: <NfServicosEmpresaEditarPage />
      },
      {
        path: 'nf/cidades',
        element: <NfCidadesPage />
      },
      {
        path: 'nf/cidade/cadastrar',
        element: <NfCidadeFormPage />
      },
      {
        path: 'nf/cidade/editar',
        element: <NfCidadeFormPage />
      },
      {
        path: 'nf/config',
        element: <NfConfigFormPage />
      },
      {
        path: 'despesas/frota',
        element: <FrotaDespesasPage />
      },
      {
        path: 'despesas/clientes',
        element: <DespesasClientesPage />
      },
      {
        path: 'despesa/cliente/cadastrar',
        element: <DespesasClienteFormPage />
      },
      {
        path: 'despesa/cliente/editar',
        element: <DespesasClienteFormPage />
      },
      {
        path: 'despesas/formasPagamento',
        element: <DespesasFormasPagamentoPage />
      },
      {
        path: 'despesas/formaPagamento/cadastrar',
        element: <DespesasFormaPagamentoFormPage />
      },
      {
        path: 'despesas/formaPagamento/editar',
        element: <DespesasFormaPagamentoFormPage />
      },
      {
        path: 'despesas/cartoes',
        element: <DespesasCartoesPage />
      },
      {
        path: 'despesas/cartao/cadastrar',
        element: <DespesasCartoesFormPage />
      },
      {
        path: 'despesas/cartao/editar',
        element: <DespesasCartoesFormPage />
      },
      {
        path: 'despesas/categorias',
        element: <DespesasCategoriasPage />
      },
      {
        path: 'despesas/categoria/cadastrar',
        element: <DespesasCategoriasFormPage />
      },
      {
        path: 'despesas/categoria/editar',
        element: <DespesasCategoriasFormPage />
      },
      {
        path: 'despesas/relatorios',
        element: <RelatoriosPage />
      },
      {
        path: 'despesas/metricas',
        element: <DespesasMetricasPage />
      },
      {
        path: 'insumos/unidades',
        element: <InsumosUnidadesPage />
      },
      {
        path: 'insumos/unidade/cadastrar',
        element: <InsumosUnidadesFormPage />
      },
      {
        path: 'insumos/unidade/editar',
        element: <InsumosUnidadesFormPage />
      },
      {
        path: 'insumos/produtos',
        element: <InsumosProdutosPage />
      },
      {
        path: 'insumos/produto/cadastrar',
        element: <InsumosProdutosFormPage />
      },
      {
        path: 'insumos/produto/editar',
        element: <InsumosProdutosFormPage />
      },
      {
        path: 'insumos/locais',
        element: <InsumosLocaisPage />
      },
      {
        path: 'insumos/local/editar',
        element: <InsumosLocaisFormPage />
      },
      {
        path: 'insumos/local/cadastrar',
        element: <InsumosLocaisFormPage />
      },
      {
        path: 'insumos/pedidos',
        element: <InsumosPedidosPage />
      },
      {
        path: 'insumos/estoque',
        element: <InsumosEstoquePage />
      },
      // {
      //   path: 'despesas/categoria/editar',
      //   element: <DespesasCategoriasFormPage />
      // },
      {
        path: 'painelControle/empresas',
        element: <EmpresasPage />
      },
      {
        path: 'painelControle/empresas/cadastrar',
        element: <EmpresaCadastrarPage />
      },
      {
        path: 'painelControle/empresas/editar',
        element: <EmpresaCadastrarPage />
      },
      {
        path: 'painelControle/cargos',
        element: <CargosPage />
      },
      {
        path: 'painelControle/cargos/cadastrar',
        element: <CargosCadastrarEditarPage />
      },
      {
        path: 'painelControle/cargos/editar',
        element: <CargosCadastrarEditarPage />
      },
      {
        path: 'painelControle/centroCusto/cadastrar',
        element: <CentroCustoCadastrarPage />
      },
      {
        path: 'painelControle/centroCusto/editar',
        element: <CentroCustoCadastrarPage />
      },
      {
        path: 'painelControle/centroCusto',
        element: <CentroCustoPage />
      },
      {
        path: 'painelControle/localTrabalho',
        element: <LocalTrabalhoPage />
      },
      {
        path: 'painelControle/localTrabalho/cadastrar',
        element: <LocalTrabalhoFormPage />
      },
      {
        path: 'painelControle/localTrabalho/editar',
        element: <LocalTrabalhoFormPage />
      },
      {
        path: 'painelControle/situacoes',
        element: <SituacoesPage />
      },
      {
        path: 'painelControle/situacoes/cadastrar',
        element: <SituacoesFormPage />
      },
      {
        path: 'painelControle/situacoes/editar',
        element: <SituacoesFormPage />
      },
      {
        path: 'painelControle/definicoesApp',
        element: <DefinicoesAppPage />
      },
      {
        path: 'painelControle/usuarios',
        element: <UsuariosPage />
      },
      {
        path: 'painelControle/usuarios/cadastrar',
        element: <UsuariosFormPage />
      },
      {
        path: 'painelControle/usuarios/editar',
        element: <UsuariosFormPage />
      },
      {
        path: 'qrcode/cadastros',
        element: <QrCodesPage />
      },
      {
        path: 'qrcode/cadastrar',
        element: <QrCodeCadastrarPage />
      },
      {
        path: 'qrcode/editar',
        element: <QrCodeCadastrarPage />
      },
      {
        path: 'qrcode/registros',
        element: <QrCodesRegistrosPage />
      },
      {
        path: 'qrcode/registros/relatorio',
        element: <QrCodeRondaMapaRelatorioPage />
      },
      {
        path: 'qrcode/rondas',
        element: <RondasPage />
      },
      {
        path: 'qrcode/rondas/registros',
        element: <RondasRegistrosPage />
      },
      {
        path: 'documentos/pendentes',
        element: <DocumentosPendentesPage />
      },
      {
        path: 'documentos/todos',
        element: <DocumentosPage />
      },
      {
        path: 'documento',
        element: <DocumentoViewPage />
      },
      {
        path: 'documento/novo',
        element: <DocumentoNovoPage />
      },
      {
        path: 'documentos/lixeira',
        element: <DocumentosLixeiraPage />
      },
    ]
  },
  {
    path: '/login',
    element: <LoginPage />
  }
])

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ToastContainer containerId={1} />
      <RouterProvider router={router} />
      <ResetCss />
      <GlobalCss />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
